import React, { useState, Fragment } from "react";

import List from "./List";
import Item from "./Item";
import Card from "../UI/Card/Card";
import styles from "./Recommendations.module.css";
import parse from "html-react-parser";

const Recommendations = (props) => {
  const [theLabel, setTheLabel] = useState(props.label);
  const [theLink, setTheLink] = useState(props.link);
  const [itemId, setItemId] = useState(0);
  if(theLabel !== props.label) {
    setTheLabel(props.label);
    setTheLink(props.link);
    setItemId(0);
  }
  const selectedItemHandler = (index) => (event) => {
    setItemId(index);
  };
  var listItems = props.items.map((row) => {
    return (
      <List key={row.id} onClick={selectedItemHandler(row.id)}>
        <div className={styles.id}>{row.id}.</div>
        <div className={styles.title}>{parse(row.title)}</div>
      </List>
    );
  });
  return (
    <Fragment>
      <Card className={styles.recommendations}>
        <div className={styles.label}><a href={theLink} target="_blank" rel="noreferrer">Recommendations for {theLabel}</a>:</div>
        {listItems}
      </Card>
      <div>- - - - -</div>
      <Card className={itemId !== 0 ? styles.recommendations : styles.hidden}>
        <Item id={itemId} items={props.items} />
      </Card>
    </Fragment>
  );
};

export default Recommendations;
